module.exports = __webpack_public_path__ + "static/img/volunteerservicelist.1cb098e0.png";